<template>

      

        <div id="rev_slider_4_2_wrapper" class="rev_slider_wrapper fullwidthbanner-container slide-overlay" data-alias="classic4export" data-source="gallery">

            <!-- START REVOLUTION SLIDER 5.4.8 auto mode -->
            <div id="rev_slider_4_2" class="rev_slider fullwidthabanner" data-version="5.4.8.2">
                <ul>


                    
                    <li data-index="rs-6" data-transition="fade" data-slotamount="default" data-hideafterloop="0" data-hideslideonmobile="off" data-easein="default" data-easeout="default" data-masterspeed="300" data-thumb="images/slides/slider-mainbg-001.jpg" data-rotate="0" data-saveperformance="off" data-title="Slide" data-param1="" data-param2="" data-param3="" data-param4="" data-param5="" data-param6="" data-param7="" data-param8="" data-param9="" data-param10="" data-description="">

                        <img src="/img/adjust.png" alt="" title="mainslider-bg001" width="1920" height="750" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat" class="rev-slidebg" data-no-retina>

                        <div class="tp-caption tp-resizeme" id="slide-6-layer-1" data-x="['left','left','left','left']" data-hoffset="['50','40','-220','-220']" data-y="['top','top','top','top']" data-voffset="['160','158','63','63']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-visibility="['on','on','off','off']"
                        data-type="image"
                        data-responsive_offset="on"
                        data-frames='[{"delay":180,"speed":500,"frame":"0","from":"z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]">

                            <img src="/img/bnew.png" alt="" data-ww="['113px','113px','113px','113px']" data-hh="['45px','45px','45px','45px']" width="113" height="45" data-no-retina> 

                        </div>

                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-6-layer-2" data-x="['left','left','left','center']" data-hoffset="['175','163','30','0']" data-y="['top','top','top','middle']" data-voffset="['178','175','76','-115']"
                        data-fontsize="['16','16','15','13']"
                        data-lineheight="['16','16','15','13']"
                        data-fontweight="['400','400','400','300']"
                        data-color="['rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)']"
                        data-letterspacing="1"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-type="text"
                        data-responsive_offset="on"
                        data-frames='[{"delay":330,"speed":500,"frame":"0","from":"x:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power3.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]">WE GIVE YOU THE BEST! </div>

                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-6-layer-3" data-x="['left','left','left','center']" data-hoffset="['50','40','30','0']" data-y="['top','top','top','middle']" data-voffset="['213','211','106','-75']"
                        data-fontsize="['75','80','60','40']"
                        data-lineheight="['80','80','55','40']"
                        data-fontweight="['600','600','600','600']"
                        data-color="['rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-type="text"
                        data-responsive_offset="on"
                        data-frames='[{"delay":470,"speed":800,"frame":"0","from":"x:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]"><strong class="ttm-textcolor-skincolor">Agricultural  </strong> </div>


                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-6-layer-4" data-x="['left','left','left','center']" data-hoffset="['50','40','30','0']" data-y="['top','top','top','middle']" data-voffset="['286','286','167','-33']"
                        data-fontsize="['75','80','60','40']"
                        data-lineheight="['80','80','60','40']"
                        data-fontweight="['600','600','600','600']"
                        data-color="['rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-type="text"
                        data-responsive_offset="on"
                        data-frames='[{"delay":900,"speed":800,"frame":"0","from":"x:[-100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]">Property <strong class="ttm-textcolor-skincolor">Managers</strong> </div>

                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-6-layer-5" data-x="['left','left','left','center']" data-hoffset="['50','40','30','0']" data-y="['top','top','top','middle']" data-voffset="['373','382','236','19']"
                        data-fontsize="['16','16','15','12']"
                        data-lineheight="['25','25','26','18']"
                        data-fontweight="['400','400','400','400']"
                        data-color="['rgb(237, 237, 237)','rgb(237, 237, 237)','rgb(237, 237, 237)','rgb(237, 237, 237)']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-type="text"
                        data-responsive_offset="on"
                        data-frames='[{"delay":1100,"speed":500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','center']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]">Need professional help? Our support staff will answer your questions.<br> Visit us Now or Make an Appointment! </div>

                        <!-- <div class="tp-caption shape-rounded tp-resizeme" id="slide-6-layer-7" data-x="['center','center','center','center']" data-hoffset="['544','446','332','332']" data-y="['middle','middle','middle','middle']" data-voffset="['219','240','150','150']"
                        data-width="50"
                        data-height="48"
                        data-fontsize="['23','23','23','23']"
                        data-lineheight="['48','48','48','48']"
                        data-fontweight="['400','400','400','400']"
                        data-color="['rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)']"
                        data-whitespace="nowrap"
                        data-visibility="['on','on','on','off']"
                        data-type="text"
                        data-responsive_offset="on"
                        data-frames='[{"delay":1240,"speed":500,"frame":"0","from":"z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['center','center','center','center']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]"><span class=" fa fa-user-md"></span> </div> -->

                        <!-- <div class="tp-caption icon-text tp-resizeme" id="slide-6-layer-8" data-x="['center','center','center','center']" data-hoffset="['444','349','235','442']" data-y="['middle','middle','middle','middle']" data-voffset="['207','227','138','95']"
                        data-fontsize="['19','19','19','18']"
                        data-lineheight="['21','21','21','20']"
                        data-fontweight="['400','400','400','400']"
                        data-color="['rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-visibility="['on','on','on','off']"
                        data-type="text"
                        data-responsive_offset="on"
                        data-frames='[{"delay":1350,"speed":500,"frame":"0","from":"x:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]">Dr. Alex Murry </div> -->

                        <!-- <div class="tp-caption icon-desc tp-resizeme" id="slide-6-layer-9" data-x="['center','center','center','center']" data-hoffset="['352','259','152','360']" data-y="['middle','middle','middle','middle']" data-voffset="['231','251','162','125']"
                        data-fontsize="['15','15','14','13']"
                        data-lineheight="['15','15','15','13']"
                        data-fontweight="['400','400','400','400']"
                        data-color="['rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)','rgb(255,255,255)']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-visibility="['on','on','on','off']"
                        data-type="text"
                        data-responsive_offset="on"
                        data-frames='[{"delay":1570,"speed":300,"frame":"0","from":"x:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]">Get an Appointment</div> -->

                        <!-- <a class="tp-caption icon-btn tp-resizeme" href="#" target="_self" id="slide-6-layer-10" data-x="['center','center','center','center']" data-hoffset="['466','373','259','465']" data-y="['middle','middle','middle','middle']" data-voffset="['230','250','161','123']"
                        data-fontsize="['15','15','14','13']"
                        data-lineheight="['15','15','14','13']"
                        data-fontweight="['400','400','400','600']"
                        data-color="['rgb(0, 214, 163)','rgb(0, 214, 163)','rgb(0, 214, 163)','rgb(0, 214, 163)']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-visibility="['on','on','on','off']"
                        data-type="text"
                        data-actions=''
                        data-responsive_offset="on"
                        data-frames='[{"delay":1570,"speed":300,"frame":"0","from":"x:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[0,0,0,0]"
                        data-paddingright="[0,0,0,0]"
                        data-paddingbottom="[0,0,0,0]"
                        data-paddingleft="[0,0,0,0]"><u>Learn More</u></a> -->

                        <router-link tag="a" to="/asset-management" class="tp-caption white-flatborder-button tp-resizeme" id="slide-6-layer-6" data-x="['left','left','left','center']" data-hoffset="['50','40','30','0']" data-y="['top','top','top','middle']" data-voffset="['467','482','319','89']"
                        data-fontsize="['13','13','13','12']"
                        data-lineheight="['16','16','16','12']"
                        data-fontweight="['600','600','600','600']"
                        data-letterspacing="['1','1','0','0']"
                        data-width="none"
                        data-height="none"
                        data-whitespace="nowrap"
                        data-type="text"
                        data-actions=''
                        data-responsive_offset="on"
                        data-frames='[{"delay":1480,"speed":500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                        data-textAlign="['inherit','inherit','inherit','inherit']"
                        data-paddingtop="[17,17,17,15]"
                        data-paddingright="[30,30,23,20]"
                        data-paddingbottom="[17,17,17,15]"
                        data-paddingleft="[30,30,23,20]">MAKE AN APPOINTMENT! </router-link>

                    </li>



                    <!-- <li data-index="rs-8" data-transition="fade" data-slotamount="default" data-hideafterloop="0" data-hideslideonmobile="off" data-easein="default" data-easeout="default" data-masterspeed="300" data-rotate="0" data-saveperformance="off" data-title="Slide" data-param1="" data-param2="" data-param3="" data-param4="" data-param5="" data-param6="" data-param7="" data-param8="" data-param9="" data-param10="" data-description="">

                        <img src="/img/slide1.png" alt="" title="mainslider-bg004" width="1918" height="710" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat" class="rev-slidebg" data-no-retina>

                        <div class="tp-caption slide-main-text shape-rectangle tp-resizeme" id="slide-8-layer-2" data-x="['left','left','center','center']" data-hoffset="['50','40','0','0']" data-y="['middle','middle','middle','middle']" data-voffset="['-164','-163','-141','-107']"
                            data-fontsize="['12','12','12','10']"
                            data-lineheight="['12','12','12','10']"
                            data-fontweight="['400','400','400','400']"
                            data-letterspacing="['2','2','1','1']"
                            data-color="['rgb(255, 255, 255)','rgb(255, 255, 255)','rgb(255, 255, 255)','rgb(255, 255, 255)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":80,"split":"chars","splitdelay":0.05,"speed":350,"split_direction":"forward","frame":"0","from":"x:[105%];z:0;rX:45deg;rY:0deg;rZ:90deg;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[15,15,10,8]"
                            data-paddingright="[20,20,15,18]"
                            data-paddingbottom="[15,15,10,8]"
                            data-paddingleft="[20,20,15,18]">LED BY PASSIONATE EXPERTS 
                        </div>
                            
                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-8-layer-8" data-x="['left','left','center','center']" data-hoffset="['50','40','0','0']" data-y="['top','top','top','middle']" data-voffset="['222','195','109','-60']"
                            data-fontsize="['75','75','65','40']"
                            data-lineheight="['75','75','65','40']"
                            data-fontweight="['600','600','600','600']"
                            data-color="['rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":300,"speed":800,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]">We are Professional Farmland
                        </div>

                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-8-layer-9" data-x="['left','left','center','center']" data-hoffset="['50','40','0','0']" data-y="['top','top','top','top']" data-voffset="['295','271','170','134']"
                            data-fontsize="['75','75','65','40']"
                            data-lineheight="['75','75','75','50']"
                            data-fontweight="['600','600','600','600']"
                            data-color="['rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":520,"speed":800,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]">and Rural Property Managers! 
                        </div>

                        <div class="tp-caption slide-desc-text tp-resizeme" id="slide-8-layer-10" data-x="['left','left','center','left']" data-hoffset="['50','40','-664','-579']" data-y="['top','top','top','top']" data-voffset="['386','362','214','233']"
                            data-fontsize="['17','17','15','15']"
                            data-lineheight="['27','27','25','25']"
                            data-fontweight="['400','400','400','400']"
                            data-color="['rgb(162, 195, 169)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-visibility="['on','on','off','off']"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":810,"speed":600,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','center','inherit']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]">"the ultimate goal of Farming is not the growing of crops,<br> but the cultivation and perfection of human beings"  Masanobu Fukuoka 
                        </div>
                        
                          
                        <router-link tag="a" to="/farmland-subscription" class="tp-caption dark-flatborder-button tp-resizeme"  id="slide-8-layer-14" data-x="['left','left','center','center']" data-hoffset="['50','41','0','0']" data-y="['middle','middle','middle','middle']" data-voffset="['151','151','70','52']"

                            data-fontsize="['13','13','13','11']"
                            data-lineheight="['13','13','13','11']"
                            data-letterspacing="['1','1','0','0']"
                            data-fontweight="700"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-actions=''
                            data-responsive_offset="on"
                            data-frames='[{"delay":1090,"speed":500,"frame":"0","from":"y:50px;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"},{"frame":"hover","speed":"300","ease":"Linear.easeNone","to":"o:1;rX:0;rY:0;rZ:0;z:0;","style":"c:rgb(255,255,255);bg:rgb(0,46,58);bc:rgb(32,41,47);br:0px 0px 0px 0px;"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[19,19,19,15]"
                            data-paddingright="[30,30,30,25]"
                            data-paddingbottom="[19,19,19,15]"
                            data-paddingleft="[30,30,30,25]" >VIEW MORE DETAILS 
                        </router-link>

                        <a class="tp-caption skin-flat-button tp-resizeme" href="https://app.agropark.ng/#/register" id="slide-8-layer-15" data-x="['left','left','center','center']" data-hoffset="['278','251','0','0']" data-y="['middle','middle','middle','middle']" data-voffset="['151','151','142','112']"

                            data-fontsize="['13','13','13','11']"
                            data-lineheight="['19','19','19','16']"
                            data-letterspacing="['1','1','0','0']"
                            data-fontweight="700"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-actions=''
                            data-responsive_offset="on"
                            data-frames='[{"delay":1190,"speed":500,"frame":"0","from":"y:50px;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"},{"frame":"hover","speed":"300","ease":"Linear.easeNone","to":"o:1;rX:0;rY:0;rZ:0;z:0;","style":"c:rgb(255,255,255);bg:rgb(0,46,58);br:0px 0px 0px 0px;"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[17,17,17,15]"
                            data-paddingright="[30,30,23,25]"
                            data-paddingbottom="[17,17,17,15]"
                            data-paddingleft="[30,30,23,25]">SUBSCRIBE NOW
                        </a>

                    </li> -->

                    <!-- <li data-index="rs-17" data-transition="fade" data-slotamount="default" data-hideafterloop="0" data-hideslideonmobile="off" data-easein="default" data-easeout="default" data-masterspeed="300" data-rotate="0" data-saveperformance="off" data-title="Slide" data-param1="" data-param2="" data-param3="" data-param4="" data-param5="" data-param6="" data-param7="" data-param8="" data-param9="" data-param10="" data-description="">

                        <img src="/img/slide2.png" alt="" title="mainslider-bg003" width="1918" height="710" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat" class="rev-slidebg" data-no-retina>

                        <div class="tp-caption slide-main-text shape-rectangle tp-resizeme" id="slide-17-layer-2" data-x="['left','left','center','center']" data-hoffset="['50','40','0','0']" data-y="['middle','middle','middle','middle']" data-voffset="['-164','-163','-141','-107']"
                            data-fontsize="['12','12','12','10']"
                            data-lineheight="['12','12','12','10']"
                            data-letterspacing="['2','2','1','1']"
                            data-fontweight="['400','400','400','400']"
                            data-color="['rgb(255, 255, 255)','rgb(255, 255, 255)','rgb(255, 255, 255)','rgb(255, 255, 255)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":10,"split":"chars","splitdelay":0.05,"speed":350,"split_direction":"forward","frame":"0","from":"x:[105%];z:0;rX:45deg;rY:0deg;rZ:90deg;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[15,15,10,8]"
                            data-paddingright="[20,20,15,18]"
                            data-paddingbottom="[15,15,10,8]"
                            data-paddingleft="[20,20,15,18]">LED BY PASSIONATE EXPERTS 
                        </div>

                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-17-layer-8" data-x="['left','left','center','center']" data-hoffset="['50','40','0','0']" data-y="['top','top','top','middle']" data-voffset="['222','195','109','-60']"
                            data-fontsize="['75','75','65','40']"
                            data-lineheight="['75','75','65','40']"
                            data-fontweight="['600','600','600','600']"
                            data-color="['rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":300,"speed":800,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]">Rear Animals that 
                        </div>

                        <div class="tp-caption slide-main-text tp-resizeme" id="slide-17-layer-9" data-x="['left','left','center','center']" data-hoffset="['50','40','0','0']" data-y="['top','top','top','top']" data-voffset="['295','271','170','134']"
                            data-fontsize="['75','75','65','40']"
                            data-lineheight="['75','75','75','50']"
                            data-fontweight="['600','600','600','600']"
                            data-color="['rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":520,"speed":800,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]">are 100% Naturally bred
                        </div>

                        <div class="tp-caption slide-desc-text tp-resizeme" id="slide-17-layer-10" data-x="['left','left','center','left']" data-hoffset="['50','40','-664','-579']" data-y="['top','top','top','top']" data-voffset="['386','362','214','233']"
                            data-fontsize="['17','17','15','15']"
                            data-lineheight="['27','27','25','25']"
                            data-fontweight="['400','400','400','400']"
                            data-color="['rgb(162, 195, 169)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-visibility="['on','on','off','off']"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":810,"speed":600,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','center','inherit']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]">"agriculture not only gives riches to a nation,<br> but the only riches she can call her own" Samuel Johnson 
                        </div>

                        <router-link tag="a" to="/poultry-subscription" class="tp-caption dark-flatborder-button" id="slide-17-layer-14" data-x="['left','left','center','center']" data-hoffset="['50','41','0','0']" data-y="['middle','middle','middle','middle']" data-voffset="['151','151','60','52']"
                            data-fontsize="['13','13','13','11']"
                            data-lineheight="['13','13','13','11']"
                            data-fontweight="700"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-actions=''
                            data-responsive_offset="on"
                            data-frames='[{"delay":1090,"speed":500,"frame":"0","from":"y:50px;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[19,19,19,15]"
                            data-paddingright="[30,30,30,25]"
                            data-paddingbottom="[19,19,19,15]"
                            data-paddingleft="[30,30,30,25]">VIEW MORE DETAILS 
                        </router-link>

                        <a class="tp-caption shape-round ttm-video-icon ttm_prettyphoto" href="https://youtu.be/e13TGGccvT4" target="_self" id="slide-17-layer-15" data-x="['left','left','center','center']" data-hoffset="['289','251','0','0']" data-y="['middle','middle','middle','middle']" data-voffset="['151','151','126','112']"

                            data-fontsize="['18','18','15','15']"
                            data-lineheight="['58','58','50','50']"
                            data-letterspacing="['0','0','1','1']"
                            data-color="['rgb(255, 255, 255)','rgb(255, 255, 255)','rgb(255, 255, 255)','rgb(255, 255, 255)']"
                            data-width="['58','58','50','50']"
                            data-height="['58','58','50','50']"
                            data-whitespace="nowrap"
                            data-type="text"
                            data-actions=''
                            data-responsive_offset="on"
                            data-frames='[{"delay":1190,"speed":500,"frame":"0","from":"y:50px;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['center','center','center','center']"
                            data-paddingtop="[,,,]"
                            data-paddingright="[,,,]"
                            data-paddingbottom="[,,,]"
                            data-paddingleft="[,,,]"><i class="fa fa-play"></i> 
                        </a>

                        <div class="tp-caption tp-resizeme" id="slide-17-layer-17" data-x="['left','left','center','center']" data-hoffset="['358','321','0','-396']" data-y="['middle','middle','middle','middle']" data-voffset="['151','151','164','133']"

                            data-fontsize="['13','13','13','13']"
                            data-lineheight="['13','13','13','13']"
                            data-letterspacing="['1','1','1','1']"
                            data-fontweight="['700','700','700','700']"
                            data-color="['rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)','rgb(0, 46, 58)']"
                            data-width="none"
                            data-height="none"
                            data-whitespace="nowrap"
                            data-visibility="['on','on','on','off']"
                            data-type="text"
                            data-responsive_offset="on"
                            data-frames='[{"delay":1190,"speed":500,"frame":"0","from":"y:50px;opacity:0;","to":"o:1;","ease":"Power0.easeIn"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                            data-textAlign="['inherit','inherit','inherit','inherit']"
                            data-paddingtop="[0,0,0,0]"
                            data-paddingright="[0,0,0,0]"
                            data-paddingbottom="[0,0,0,0]"
                            data-paddingleft="[0,0,0,0]">HOW WE WORK 
                        </div>
                    </li> -->
                </ul>
            </div>
        </div>
       <!-- END REVOLUTION SLIDER -->

  
</template>

<script>
export default {
  name: "Slider",
  props: {}
};
</script>

<style scoped>

</style>







